<template lang="pug">
  svg.svg-counter(:x="x" :y="y" :width="width" :height="height" viewBox="0 0 100 325" preserveAspectRatio="none")
    title Counter
    rect.counter-cls-1(x="0.5" y="284" width="99" height="40")
    rect.counter-cls-2(x="0.5" y="0.5" width="99" height="12")
    rect.counter-cls-3(x="0.5" y="13"  width="99" height="270")
</template>

<script>
export default {
  name: 'svg-counter',

  props: {
    x: Number,
    y: Number,
    width: Number,
    height: {
      type: Number,
      default: 325,
    },
  },

};
</script>

<style lang="scss" scoped>
.svg-counter {

  .counter-cls-1 {
    fill: var(--fill-color-1, #000);
    stroke: var(--stroke-color-1, #000);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
  .counter-cls-2 {
    fill: var(--fill-color-2, #e6e6e6);
    stroke: var(--stroke-color-2, #000);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
  .counter-cls-3 {
    fill: var(--fill-color-3, #333);
    stroke: var(--stroke-color-3, #000);
    stroke-width: var(--stroke-width-3, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
}
</style>
